<template>
  <el-dialog
    class="dialog"
    title="设置选调函"
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    width="680px"
    destroy-on-close
    :before-close="handleClose"
  >
    <div class="content">
      <span class="title">选调函模板：</span>
      <weditor :detail.sync="template" @change-con="changeCon" />
    </div>
    <el-dialog
      width="680px"
      title="预览选调函"
      :visible.sync="previewVisible"
      append-to-body
    >
      <div class="pdf-content">
        <div v-for="(item, index) in previewList" :key="item.classEnrollId">
          <div :class="index == 0 ? 'pdf-item first-one' : 'pdf-item'">
            <div v-html="item.content"></div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handlePreviewClose" size="small">取消</el-button>
        <el-button type="primary" @click="handlePublish" size="small"
          >发布</el-button
        >
      </span>
    </el-dialog>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">取消</el-button>
      <el-button :disabled="!(newTemplate && newTemplate.length > 0)" type="primary" @click="confirm" size="small">预览</el-button>
    </span>
  </el-dialog>
</template>

<script>
import weditor from "@/components/weditor/transferWeditor.vue";
// import vue from "../../../main";
import {
  previewTransfer,
  publishTransfer,
} from "@/api/selectionLetter";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    classId: {
      type: String,
      default: null,
    },
    template: {
      type: String,
      default: null,
    }
  },
  components: { weditor },
  data() {
    return {
      previewVisible: false,
      newTemplate: null,
      previewList: [],
      selectedUsers: [],
    };
  },
  watch: {
    // "dialogVisible" : {
    //   handler(val) {
    //     if (val) {
    //       this.getTransferInfo();
    //     }
    //   }
    // }
  },
  created() {

  },
  methods: {
    setSelections(val) {
      this.selectedUsers = val;
    },
    changeCon(val) {
      this.newTemplate = val;
    },
    // 关闭
    handleClose() {
      this.$emit("close");
    },
    // 确定
    confirm() {
      previewTransfer({ classId: this.classId, content: this.newTemplate, classEnrollIds: this.selectedUsers }).then(
        (res) => {
          if (!res || res.code != 0) return;
          //  获取数据
          this.previewList = res.data;
          this.previewVisible = true;
        }
      );
    },
    // 预览dialog取消
    handlePreviewClose() {
      this.previewVisible = false;
    },
    // 发布
    handlePublish() {
      publishTransfer({ classId: this.classId, content: this.newTemplate, classEnrollIds: this.selectedUsers }).then(
        (res) => {
          if (!res || res.code != 0) return;
          //  获取数据
          this.previewVisible = false;
          this.$emit("confirm");
          this.handleClose();
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  /deep/ .el-dialog__body {
    max-height: 500px;
    overflow-y: scroll;
    padding: 20px;
  }
  .content {
    display: flex;
    flex-direction: column;
    .title {
      margin-bottom: 10px;
    }
  }
}
.pdf-content {
  .pdf-item {
    margin-left: 10px;
    margin-right: 10px;
    padding: 20px 30px;
    box-shadow: 0px 0px 3px 3px #dedede;
    margin-top: 30px;
  }
  .first-one {
    margin-top: 0px;
  }
}
</style>
